export enum StipendCalendarType {
  Hebrew = 1,
  Gregorian = 2
}
